import script from "./ClausulasComerciaisForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ClausulasComerciaisForm.vue?vue&type=script&setup=true&lang=js"

import "./ClausulasComerciaisForm.vue?vue&type=style&index=0&id=ceb4287e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceb4287e"]])

export default __exports__